import React, { useContext } from 'react';
import { Link, Typography } from '@material-ui/core';
import { useLastModified } from '../../hooks/useChangelog';
import moment from 'moment-timezone';
import 'moment/locale/fr';
import { CentralProviderContext, Languages, useTranslation } from '@michelin/central-provider';
export default function (props) {
    const { callback, api, app, entity, identifier, filters, shouldRefresh = false } = props;
    const providerContext = useContext(CentralProviderContext);
    const APP = providerContext.application || app || '';
    const { t } = useTranslation();
    const onClickHandler = (e) => {
        e.stopPropagation();
        callback();
    };
    const lastModifiedQuery = useLastModified(api, APP, entity, shouldRefresh, identifier, filters);
    let lab = 'Not Started';
    const lang = (providerContext.currentLanguage || 'EN_US').split('_')[0].toLowerCase();
    moment.locale(lang);
    if (lastModifiedQuery.data) {
        switch (providerContext.currentLanguage) {
            case Languages.EN_US:
                lab = moment(lastModifiedQuery.data).tz('America/New_York').format('LL');
                break;
            case Languages.FR_CA:
                lab = moment(lastModifiedQuery.data).tz('America/Toronto').format('LL');
                break;
            default:
                lab = moment(lastModifiedQuery.data).tz('America/New_York').format('LL');
                break;
        }
    }
    return (React.createElement(React.Fragment, null, lab && (React.createElement(Link, { style: { cursor: 'pointer' }, variant: "body2", color: "primary", onClick: onClickHandler },
        React.createElement(Typography, { style: { fontSize: '0.8rem' } },
            React.createElement(React.Fragment, null,
                React.createElement("span", { style: { whiteSpace: 'nowrap', fontSize: '11px' } }, t('Last modified')),
                React.createElement("br", null),
                React.createElement("span", { style: { whiteSpace: 'nowrap' } }, lab)))))));
}
//# sourceMappingURL=LastModifiedButton.js.map